var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5L12.5 5.5H9.5V2.5ZM8.75 5.5C8.75 5.92188 9.07812 6.25 9.5 6.25H12.5V13.375C12.5 14.0078 11.9844 14.5 11.375 14.5H4.625C3.99219 14.5 3.5 14.0078 3.5 13.375V3.625C3.5 3.01562 3.99219 2.5 4.625 2.5H8.75V5.5ZM9.875 12.25C10.0625 12.25 10.25 12.0859 10.25 11.875C10.25 11.6875 10.0625 11.5 9.875 11.5H6.125C5.91406 11.5 5.75 11.6875 5.75 11.875C5.75 12.0859 5.91406 12.25 6.125 12.25H9.875ZM9.875 10.75C10.0625 10.75 10.25 10.5859 10.25 10.375C10.25 10.1875 10.0625 10 9.875 10H6.125C5.91406 10 5.75 10.1875 5.75 10.375C5.75 10.5859 5.91406 10.75 6.125 10.75H9.875ZM10.25 8.875C10.25 8.6875 10.0625 8.5 9.875 8.5H6.125C5.91406 8.5 5.75 8.6875 5.75 8.875C5.75 9.08594 5.91406 9.25 6.125 9.25H9.875C10.0625 9.25 10.25 9.08594 10.25 8.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/IconReport.431893e9dd0d4f74349219d2d9f0d925.svg";
export { ForwardRef as ReactComponent };